
import { logger } from './logger';
import { getStoredInterestData } from './interestDataUtils';

export interface NavigationHistoryEntry {
  dateStamp: string;
  pageURL: string;
  chatVehicleInterest: any;
}

const NAVIGATION_HISTORY_KEY = 'Navigation_History';

export const addNavigationHistoryEntry = (): void => {
  try {
    logger.log('=== ADDING NAVIGATION HISTORY ENTRY ===');
    
    const dateStamp = new Date().toISOString();
    const pageURL = window.location.href;
    const chatVehicleInterest = getStoredInterestData();
    
    const newEntry: NavigationHistoryEntry = {
      dateStamp,
      pageURL,
      chatVehicleInterest
    };
    
    logger.log('New navigation entry:', JSON.stringify(newEntry, null, 2));
    
    // Get existing history
    const existingHistory = getNavigationHistory();
    
    // Add new entry to the beginning of the array
    const updatedHistory = [newEntry, ...existingHistory];
    
    // Store updated history
    localStorage.setItem(NAVIGATION_HISTORY_KEY, JSON.stringify(updatedHistory));
    
    logger.log('✅ Navigation history entry added successfully');
    logger.log('Total navigation entries:', updatedHistory.length);
  } catch (error) {
    logger.error('Error adding navigation history entry:', error);
  }
};

export const getNavigationHistory = (): NavigationHistoryEntry[] => {
  try {
    const storedHistory = localStorage.getItem(NAVIGATION_HISTORY_KEY);
    if (!storedHistory) {
      return [];
    }
    
    const parsedHistory = JSON.parse(storedHistory);
    return Array.isArray(parsedHistory) ? parsedHistory : [];
  } catch (error) {
    logger.error('Error retrieving navigation history:', error);
    return [];
  }
};

export const clearNavigationHistory = (): void => {
  try {
    localStorage.removeItem(NAVIGATION_HISTORY_KEY);
    logger.log('Navigation history cleared');
  } catch (error) {
    logger.error('Error clearing navigation history:', error);
  }
};

export const getNavigationHistoryCount = (): number => {
  return getNavigationHistory().length;
};
